(() => {
  const initialized = new WeakSet();

  const initialize = (panel) => {
    if (initialized.has(panel)) return;
    initialized.add(panel);
    const roots = new WeakSet();
    let attempts = 0;

    const enhance = (embed) => {
      const root = embed.shadowRoot;
      if (!root || roots.has(root)) return;
      roots.add(root);

      const stylesheet = document.createElement('link');
      stylesheet.rel = 'stylesheet';
      stylesheet.href = panel.dataset.formStyles;
      stylesheet.dataset.serenovaFinancingStyles = '';
      root.append(stylesheet);

      const update = () => {
        if (!panel.isConnected) {
          observer.disconnect();
          return;
        }

        root.querySelectorAll('textarea[name]').forEach((field) => {
          if (field.id || root.getElementById(field.name)) return;
          const label = Array.from(root.querySelectorAll('label[for]')).find((item) => item.htmlFor === field.name);
          if (label) field.id = field.name;
        });

        const privacyPolicyUrl = panel.dataset.privacyPolicyUrl;
        const disclaimer = root.querySelector('[class*="_formDisclaimer_"] p');
        const disclaimerText = disclaimer?.textContent.trim();
        const isInquiryDisclaimer = disclaimerText === 'We’ll use these details to respond to your inquiry.';
        const isDefaultDisclaimer = disclaimerText === 'View our privacy policy and terms of service.';
        if (privacyPolicyUrl && disclaimer && !disclaimer.querySelector('a') &&
            (isInquiryDisclaimer || isDefaultDisclaimer)) {
          const link = document.createElement('a');
          link.href = privacyPolicyUrl;
          link.textContent = isInquiryDisclaimer ? 'Privacy policy' : 'privacy policy';
          if (isInquiryDisclaimer) disclaimer.append(' ', link);
          else disclaimer.replaceChildren('View our ', link, '.');
        }
      };

      const observer = new MutationObserver(update);
      observer.observe(root, { childList: true, subtree: true });
      update();
    };

    const connect = () => {
      if (!panel.isConnected) return;
      const embeds = Array.from(panel.querySelectorAll('shopify-forms-embed'));
      embeds.forEach(enhance);
      if (++attempts < 120 && (!embeds.length || embeds.some((embed) => !embed.shadowRoot))) {
        setTimeout(connect, 250);
      }
    };
    connect();
  };

  const initializeAll = () => document.querySelectorAll('[data-financing-inquiry]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
  else initializeAll();
  document.addEventListener('shopify:section:load', initializeAll);
})();
